import {
  getOnboarding,
  saveOnboardingDraft,
  uploadOnboardingDocument,
  deleteOnboardingDocument,
  submitOnboarding
} from '@/api/onboarding';

const STORE_KEY = 'uconnect-onboarding-vue';

const getDefaultState = () => {
  return {
    step: 0,
    status: 'draft', // 'draft', 'under_review', 'approved', 'rejected'
    form: {
      sales_head: {
        name: '',
        rnokpp: '',
        birth: '',
        position: '',
        appointed: '',
        certificate: ''
      },
      employees: [
        {
          name: '',
          rnokpp: '',
          birth: '',
          position: '',
          appointed: '',
          certificate: ''
        }
      ]
    },
    compliance: {},
    docType: 'passport',
    noRnokpp: false,
    hasKved: true,
    taxSystem: 'simplified',
    inRegistry: true,
    hasEmployees: null, //'no',
    hasSalesHead: null, //'no',
    uploaded: {},
    insurersOff: {},
    insurersDone: false,
    totalGeneratedDocsCount: 0,
    contractRead: false,
    docsGenerated: false,
    signedContract: false,
    signedDocs: {},
    signedForms: {},
    complianceTab: 0,
    openGroup: null,
    points: 0,
    visited: { 0: true },
    // Флаги загрузки и ошибок
    isLoading: false,
    isSubmitting: false,
    statusError: null,
  };
};

const state = getDefaultState();

const getters = {
  ONBOARDING_STATE: state => state,
  ONBOARDING_STEP: state => state.step,
  ONBOARDING_FORM: state => state.form,
  ONBOARDING_POINTS: state => state.points,
  ONBOARDING_VISITED: state => state.visited,
  IS_LOADING: state => state.isLoading,
  IS_SUBMITTING: state => state.isSubmitting,
  STATUS_ERROR: state => state.statusError,
  ONBOARDING_STATUS: state => state.status,
  IS_STEP_DISABLED: (state) => (stepIndex) => {
    if (stepIndex === state.step) return false;
    return !state.visited[stepIndex];
  }
};

const mutations = {
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
    localStorage.removeItem(STORE_KEY);
  },

  INIT_ONBOARDING_STATE(state) {
    try {
      const raw = localStorage.getItem(STORE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        Object.assign(state, getDefaultState(), parsed);
      }
    } catch (e) {
      console.error('Помилка завантаження onboarding state з localStorage:', e);
    }
  },

  SAVE_ONBOARDING_STATE(state) {
    try {
       console.log('state', state)
      // state.hasEmployees = null;
      // state.hasSalesHead = null;
      // state.compliance = {};
      // console.log('state', state)
      localStorage.setItem(STORE_KEY, JSON.stringify(state));
    } catch (e) {
      console.error('Помилка збереження onboarding state у localStorage:', e);
    }
  },

  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },

  SET_SUBMITTING(state, isSubmitting) {
    state.isSubmitting = isSubmitting;
  },

  SET_STATUS_ERROR(state, error) {
    state.statusError = error;
  },

  SET_STEP(state, stepIndex) {
    state.step = stepIndex;
    // state.visited[stepIndex] = true;
    state.visited = {
      ...state.visited,
      [stepIndex]: true
    };
  },

  UPDATE_FORM_FIELD(state, { field, value }) {
    state.form[field] = value;
  },

  SET_COMPLIANCE_ANSWER(state, { key, value }) {
    state.compliance[key] = value;
  },

  TOGGLE_INSURER(state, code) {
    if (state.insurersOff[code]) {
      delete state.insurersOff[code];
    } else {
      state.insurersOff[code] = true;
    }
  },

  SET_DOC_UPLOADED(state, { key, data }) {
    //state.uploaded[key] = true;
    state.uploaded = {
      ...state.uploaded,
      [key]: data
    };
  },

  REMOVE_DOC_UPLOADED(state, key) {
    const updatedDocs = { ...state.uploaded };
    delete updatedDocs[key];
    state.uploaded = updatedDocs;
  },

  SET_TOTAL_GENERATED_DOCS_COUNT(state, count) {
    console.log('SET_TOTAL_GENERATED_DOCS_COUNT', count)
    state.totalGeneratedDocsCount = count;
  },

  SIGN_DOCUMENT(state, { type, id }) {
    if (type === 'contract') {
      state.signedContract = true;
    } else if (type === 'doc') {
      state.signedDocs[id] = true;
    } else if (type === 'form') {
      state.signedForms[id] = true;
    }
  },

  ADD_POINTS(state, points) {
    state.points += points;
  },

  SET_STATE_PROPERTY(state, { key, value }) {
    if (Object.prototype.hasOwnProperty.call(state, key)) {
      state[key] = value;
    }
  },

  // Обновление состояния данными, полученными с бэкенда
  SET_SERVER_ONBOARDING_DATA(state, serverPayload) {
    // if (!payload) return;
    // if (payload.step !== undefined) state.step = payload.step;
    // if (payload.status) state.status = payload.status;
    // if (payload.documents) state.uploaded = payload.documents;
    if (!serverPayload) return;
    console.log('serverPayload', serverPayload);

    const data = serverPayload.data || serverPayload;//{};

    const currentStep = serverPayload.step ?? 0;
    // 1. Скалярные данные верхнего уровня
    if (serverPayload.step !== undefined) state.step = serverPayload.step;
    if (serverPayload.status !== undefined) state.status = serverPayload.status;

    // Поддержка ключей 'documents' и 'uploaded'
    const docs = serverPayload.documents || serverPayload.uploaded;
    if (docs) {
      state.uploaded = { ...docs };
    }

// Обработка visited (преобразуем массив [true, true] в объект {0: true, 1: true})
    let serverVisited = data.visited || { 0: true };
    if (Array.isArray(serverVisited)) {
      serverVisited = serverVisited.reduce((acc, isVisited, idx) => {
        if (isVisited) acc[idx] = true;
        return acc;
      }, {});
    }

   // const serverVisited = data?.visited || { 0: true };
    state.visited = {
      ...serverVisited,
      [currentStep]: true
    };
    console.log('data.insurersDone', data.insurersDone)

    if (data.form) state.form = { ...data.form };
    if (data.compliance) state.compliance = { ...data.compliance };
    if (data.signedDocs) state.signedDocs = { ...data.signedDocs };
    if (data.signedForms) state.signedForms = { ...data.signedForms };
    if (data.insurersOff) state.insurersOff = { ...data.insurersOff };
    if (data.insurersDone) state.insurersDone = data.insurersDone;
    if (data.totalGeneratedDocsCount) state.totalGeneratedDocsCount = { ...data.totalGeneratedDocsCount };

    if (data.docType !== undefined) state.docType = data.docType;
    if (data.noRnokpp !== undefined) state.noRnokpp = data.noRnokpp;
    if (data.hasKved !== undefined) state.hasKved = data.hasKved;
    if (data.taxSystem !== undefined) state.taxSystem = data.taxSystem;
    if (data.inRegistry !== undefined) state.inRegistry = data.inRegistry;
    if (data.hasEmployees !== undefined) state.hasEmployees = data.hasEmployees;
    if (data.hasSalesHead !== undefined) state.hasSalesHead = data.hasSalesHead;
    if (data.contractRead !== undefined) state.contractRead = data.contractRead;
    if (data.signedContract !== undefined) state.signedContract = data.signedContract;
    if (data.points !== undefined) state.points = data.points;
    console.log('MappedState', state)
  }
};

const actions = {
  async INIT_ONBOARDING({ commit }) {
    commit('INIT_ONBOARDING_STATE');
    commit('SET_LOADING', true);
    commit('SET_STATUS_ERROR', null);

    try {
      const response = await getOnboarding();
      const serverData = response?.data?.data;

      if (serverData) {
        commit('SET_SERVER_ONBOARDING_DATA', serverData);
        commit('SAVE_ONBOARDING_STATE'); // Теперь вызывается корректно!
      }

      return response;

    } catch (error) {
      const errorMsg = error.response?.data?.message || 'Не вдалося завантажити дані онбордингу';
      commit('SET_STATUS_ERROR', errorMsg);
      console.error('INIT_ONBOARDING Error:', error);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  /**
   * Сохранение чернетки (локально + отправка на бэкенд)
   */
  async SAVE_ONBOARDING({ commit, state }) {
    commit('SAVE_ONBOARDING_STATE');

    try {
      // Собираем payload для сохранения в JSON-поле data таблицы onboardings
      const payloadData = {
        form: state.form,
        compliance: state.compliance,
        docType: state.docType,
        noRnokpp: state.noRnokpp,
        hasKved: state.hasKved,
        taxSystem: state.taxSystem,
        inRegistry: state.inRegistry,
        hasEmployees: state.hasEmployees,
        hasSalesHead: state.hasSalesHead,
        insurersOff: state.insurersOff,
        insurersDone: state.insurersDone,
        docsGenerated: state.docsGenerated,
        lastGeneratedHash: null,
        contractRead: state.contractRead,
        signedContract: state.signedContract,
        signedDocs: state.signedDocs,
        signedForms: state.signedForms,
        visited: state.visited,
        points: state.points,
      };

      const response = await saveOnboardingDraft({
        step: state.step,
        data: payloadData,
      });

      return response;
    } catch (error) {
      console.error('SAVE_ONBOARDING Error:', error);
    }
  },

  RESET_ONBOARDING_STATE({ commit }) {
    commit('RESET_STATE');
  },

  SET_STEP({ commit, dispatch }, stepIndex) {
    commit('SET_STEP', stepIndex);
    return dispatch('SAVE_ONBOARDING');
  },

  async SUBMIT_ONBOARDING_STEP({ commit, dispatch }, payload) {
    if (payload?.step !== undefined) {
      commit('SET_STEP', payload.step);
    }
    return await dispatch('SAVE_ONBOARDING');
  },

  /**
   * Загрузка документа на сервер
   */
  async UPLOAD_DOCUMENT({ commit, dispatch }, { type, file }) {
    try {
      const response = await uploadOnboardingDocument(type, file);

      if (response?.data?.data) {
        commit('SET_DOC_UPLOADED', {
          key: type,
          data: response.data.data
        });
        dispatch('SAVE_ONBOARDING_STATE');
      }

      return response;
    } catch (error) {
      console.error('UPLOAD_DOCUMENT Error:', error);
      throw error;
    }
  },

  /**
   * Удаление документа с сервера
   */
  async REMOVE_DOCUMENT({ commit, dispatch }, key) {
    try {
      const response = await deleteOnboardingDocument(key);

      commit('REMOVE_DOC_UPLOADED', key);
      dispatch('SAVE_ONBOARDING_STATE');

      return response;
    } catch (error) {
      console.error('REMOVE_DOCUMENT Error:', error);
      throw error;
    }
  },

  async SEND_FINAL_ONBOARDING({ commit, dispatch }) {
    commit('SET_SUBMITTING', true);
    commit('SET_STATUS_ERROR', null);

    try {
      // Предварительно сохраняем актуальное состояние
      await dispatch('SAVE_ONBOARDING');

      const response = await submitOnboarding();

      commit('SET_STATE_PROPERTY', { key: 'status', value: 'under_review' });
      commit('SAVE_ONBOARDING_STATE');

      return response;
    } catch (error) {
      const errorMsg = error.response?.data?.message || 'Не вдалося відправити документи на перевірку';
      commit('SET_STATUS_ERROR', errorMsg);
      console.error('SEND_FINAL_ONBOARDING Error:', error);
      throw error;
    } finally {
      commit('SET_SUBMITTING', false);
    }
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
